import React from "react";

function Arrow({ color, style }) {
  // STATES
  // STORE STATES
  // HOOKS
  // METHODS
  // EFFECTS
  // RENDER
  return (
    <svg
      width="11"
      height="21"
      viewBox="0 0 11 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.28085 19.4476L6.28085 2.69796L8.83307 5.25017C9.1357 5.55286 9.62646 5.55286 9.92915 5.25017C10.0804 5.09883 10.1561 4.90047 10.1561 4.7021C10.1561 4.50374 10.0804 4.30538 9.9291 4.15409L6.05381 0.278805C5.75118 -0.02388 5.26042 -0.02388 4.95773 0.278805L1.08244 4.15409C0.77981 4.45672 0.77981 4.94749 1.08244 5.25017C1.38508 5.55286 1.87584 5.55286 2.17853 5.25017L4.73074 2.69796L4.73074 19.4476C4.73074 19.8756 5.07776 20.2227 5.5058 20.2227C5.93384 20.2227 6.28085 19.8756 6.28085 19.4476Z"
        fill={color}
      />
    </svg>
  );
}
export default Arrow;
